import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import route from '@src/constants/route';
import { createProject } from '@src/apis/project';
import { PROJECT_OPTIONS_INPUT, TYPE_UPLOAD } from '@src/constants/upload';
import { useTranslation } from 'react-i18next';
import { DEFAULT_BREAK_TIME, DEFAULT_SPEED } from '@src/constants/voice';
import { ContentState, EditorState } from 'draft-js';
import {
  useLocation,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import { BREAK_LINE_DELIMITER } from '@src/constants';
import { countTextLength, removeEmptyLineOfText } from '@src/services/tts';
import { INPUT_TTS_TYPE } from '@src/constants/tts';
import UploadFile from '@src/containers/TTS/UploadFile';
import ImportURL from '@src/containers/TTS/NewImportURL';
import ProjectInputItem from './ProjectInputItem';
import { StyledProjectInput } from './index.style';

const ProjecInput = ({ refetchProjects }) => {
  const history = useHistory();
  const [openUpload, setOpenUpload] = useState(false);
  const [openImportUrl, setOpenImportUrl] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const handleOpenUpload = () => setOpenUpload(true);
  const handleCloseUpload = () => setOpenUpload(false);

  const handleOpenImportUrl = () => setOpenImportUrl(true);
  const handleCloseImportUrl = () => setOpenImportUrl(false);

  const handleCreateProject = async (data) => {
    const res = await createProject(data);
    if (res.status) {
      // TODO: show toast
      refetchProjects(false);
    }
    return res;
  };

  const handleUploadContent = async (text) => {
    const handledText = removeEmptyLineOfText(text);

    const contentState = EditorState.createWithContent(
      ContentState.createFromText(handledText),
    ).getCurrentContent();
    const textContent = contentState.getPlainText('\n');
    const splitParagraphs = textContent.split(BREAK_LINE_DELIMITER);

    const paragraphs = splitParagraphs?.map((textParagraph) => ({
      id: uuidv4(),
      text: textParagraph,
      breakTime: DEFAULT_BREAK_TIME,
      speed: DEFAULT_SPEED,
      characters: countTextLength(textParagraph),
      elements: [
        {
          key: uuidv4(),
          text: textParagraph,
          startOffset: 0,
          endOffset: textParagraph.length,
          name: undefined,
          value: undefined,
        },
      ],
    }));

    const title = t('untitledTitleProject', {
      time: moment().format('YYYYMMDD-HH:mm'),
    });
    const data = {
      title,
      product: 'TTS',
      isDeleted: false,
      blocks: paragraphs,
    };
    const res = await handleCreateProject(data);
    if (res.status) {
      const idProject = res?.result?.project?.id;
      history.push(`${route.PROJECTS}/${idProject}`);
    }
  };

  const handleCreateProjectBase = async () => {
    const data = {
      title: t('untitledTitleProject', {
        time: moment().format('YYYYMMDD-HH:mm'),
      }),
      product: 'TTS',
      isDeleted: false,
      blocks: [
        {
          id: uuidv4(),
          characters: 0,
          speed: 1,
          elements: [],
        },
      ],
    };
    const res = await handleCreateProject(data);
    if (res.status) {
      const idProject = res?.result?.project?.id;
      history.push(`${route.PROJECTS}/${idProject}`);
    }
  };

  const handleSelectOptionInput = (_, item) => {
    switch (item.type) {
      case TYPE_UPLOAD.LINK:
        handleOpenImportUrl();
        break;
      case TYPE_UPLOAD.FILE:
        handleOpenUpload();
        break;
      case 'TEXT':
        handleCreateProjectBase();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const inputType = queryParams.get('inputType');
    switch (inputType) {
      case INPUT_TTS_TYPE.FILE:
        setOpenUpload(true);
        break;
      case INPUT_TTS_TYPE.LINK:
        setOpenImportUrl(true);
        break;
      default:
        break;
    }
  }, [location]);

  return (
    <StyledProjectInput>
      {PROJECT_OPTIONS_INPUT.map((option) => (
        <ProjectInputItem
          key={option.title}
          logo={option.icon}
          title={t(option.label)}
          option={option}
          onSelect={handleSelectOptionInput}
        />
      ))}
      <UploadFile
        open={openUpload}
        onClose={handleCloseUpload}
        onHandleUploadContent={handleUploadContent}
      />
      <ImportURL
        open={openImportUrl}
        onClose={handleCloseImportUrl}
        onHandleUploadContent={handleUploadContent}
      />
    </StyledProjectInput>
  );
};

export default ProjecInput;
